/** С возвращением: офлайн-доход и серия — представление без стора, всё приходит пропсами. */
import { BoostIcon, Button, Icon, Panel, WindowShell, compactCoins } from "../kit";
import { StreakStrip } from "../streak/view";
import { type WelcomeBackModel, splitDuration } from "./model";
import { getLocale } from "../../../i18n";
import { useT } from "../../../app";
import "./styles.css";

type T = ReturnType<typeof useT>;

function duration(t: T, seconds: number): string {
  const { h, m } = splitDuration(seconds);
  if (h > 0 && m > 0) return t("win.time.hm", { h, m });
  if (h > 0) return t("win.time.h", { h });
  return t("win.time.m", { m });
}

export interface WelcomeBackViewProps {
  model: WelcomeBackModel;
  /** Цель при входе: сколько очков до следующей награды сезона. */
  seasonGoal?: { points: number; days: number } | null;
  onClaimAll(): void;
}

export function WelcomeBackView({ model: m, seasonGoal, onClaimAll }: WelcomeBackViewProps) {
  const t = useT();
  const pct = Math.floor(m.storagePermille / 10);
  return (
    <WindowShell kind="welcomeBack" title={t("win.welcome.title")}>
      <p class="win-subtitle">{t("win.welcome.away")}</p>
      <p class="win-muted">{t("win.welcome.held", { time: duration(t, m.awaySeconds) })}</p>
      {seasonGoal && (
        <p class="win-note" data-testid="welcome-season">
          {t("win.season.goal", { n: seasonGoal.points, d: seasonGoal.days })}
        </p>
      )}
      <Panel class="win-stat win-stat--wide" testid="welcome-coins">
        <Icon name="coin" size={40} />
        <span class="win-stat__value">+{compactCoins(m.coins, getLocale())}</span>
      </Panel>
      <Panel class="win-storage" testid="welcome-storage">
        <BoostIcon boostId="boost_coin_rush" size={40} />
        <div class="win-storage__main">
          <div class="win-storage__head">
            <span>{t("win.welcome.storage")}</span>
            <span data-testid="storage-pct">{pct}%</span>
          </div>
          <div
            class="win-bar"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={pct}
            aria-label={t("win.welcome.storage")}
          >
            <span class="win-bar__fill" style={{ width: `${pct}%` }} />
          </div>
          <span class="win-muted win-small">
            {m.fullInSeconds > 0
              ? t("win.welcome.storageFullIn", { time: duration(t, m.fullInSeconds), max: duration(t, m.capSeconds) })
              : t("win.welcome.storageFull", { max: duration(t, m.capSeconds) })}
          </span>
        </div>
      </Panel>
      <Panel class="win-streak-panel">
        <h3 class="win-h3">{t("win.streak.title", { n: m.streakDay })}</h3>
        <StreakStrip days={m.streak} />
      </Panel>
      <div class="win-actions">
        <Button tone="green" onClick={onClaimAll} data-testid="welcome-claim">
          {t("win.welcome.claimAll")}
        </Button>
      </div>
    </WindowShell>
  );
}
